<template>
  <div class="discountCoupon">
    <el-card shadow="never" class="my_card">
      <!-- 顶部区域 -->
      <div class="top6 clearfix">
        <div class="fl">
          <img
            src="../../assets/images/ticons/youhuiquan_title_icon@2x (1).png"
            alt=""
          />
          <span></span><b style="font-weight:500;">优惠券分析</b>
        </div>
        <!-- 右侧区域 -->
        <div class="fr">
          <p>
            <img
              src="../../assets/images/newIcon/ss_shaixuan_icon.png"
              alt=""
            />
            <el-select
              style="width: 100px"
              v-model="options1.value"
              placeholder="请选择"
              class="my-select"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </p>
        </div>
      </div>
      <!-- 8个盒子区域 -->
      <ul>
        <li>
          <p><span class="blueBar fz14"></span><span class="fz14">昨日券的发放量</span></p>
          <p class="txtColor fz12">2021.07.09 ～ 2021.07.27｜昨日</p>
          <div class="box3">
            <div>
              <p class="blueColor fz14 date">7-27(二)</p>
              <p class="blueColor fz43">319<span class="fz14">次</span></p>
            </div>
            <div class="fz12">
              <p class="txtColor">
                环比<span class="dowmColr"
                  >5.9%<i class="el-icon-bottom"></i
                ></span>
              </p>
              <p class="txtColor">
                同比<span class="upColor">5.9%<i class="el-icon-top"></i></span>
              </p>
              <p class="txtColor">
                历史总量<span style="margin-left: 5px" class="color666"
                  >14800</span
                >
              </p>
            </div>
          </div>
        </li>
        <li>
          <p><span class="blueBar fz14"></span><span class="fz14">昨日券的领取量</span></p>
          <p class="txtColor fz12">2021.07.09 ～ 2021.07.27｜昨日</p>
          <div class="box3">
            <div>
              <p class="blueColor fz14 date">7-27(二)</p>
              <p class="blueColor fz43">319<span class="fz14">次</span></p>
            </div>
            <div class="fz12">
              <p class="txtColor">
                环比<span class="dowmColr"
                  >5.9%<i class="el-icon-bottom"></i
                ></span>
              </p>
              <p class="txtColor">
                同比<span class="upColor">5.9%<i class="el-icon-top"></i></span>
              </p>
              <p class="txtColor">
                历史总量<span style="margin-left: 5px" class="color666"
                  >14800</span
                >
              </p>
            </div>
          </div>
        </li>
        <li>
          <p><span class="blueBar fz14"></span><span class="fz14">昨日券的使用量</span></p>
          <p class="txtColor fz12">2021.07.09 ～ 2021.07.27｜昨日</p>
          <div class="box3">
            <div>
              <p class="blueColor fz14 date">7-27(二)</p>
              <p class="blueColor fz43">319<span class="fz14">次</span></p>
            </div>
            <div class="fz12">
              <p class="txtColor">
                环比<span class="dowmColr"
                  >5.9%<i class="el-icon-bottom"></i
                ></span>
              </p>
              <p class="txtColor">
                同比<span class="upColor">5.9%<i class="el-icon-top"></i></span>
              </p>
              <p class="txtColor">
                历史总量<span style="margin-left: 5px" class="color666"
                  >14800</span
                >
              </p>
            </div>
          </div>
        </li>
        <li>
          <p><span class="blueBar fz14"></span><span class="fz14">昨日券的领取人数</span></p>
          <p class="txtColor fz12">2021.07.09 ～ 2021.07.27｜昨日</p>
          <div class="box3">
            <div>
              <p class="blueColor fz14 date">7-27(二)</p>
              <p class="blueColor fz43">319<span class="fz14">次</span></p>
            </div>
            <div class="fz12">
              <p class="txtColor">
                环比<span class="dowmColr"
                  >5.9%<i class="el-icon-bottom"></i
                ></span>
              </p>
              <p class="txtColor">
                同比<span class="upColor">5.9%<i class="el-icon-top"></i></span>
              </p>
              <p class="txtColor">
                历史总量<span style="margin-left: 5px" class="color666"
                  >14800</span
                >
              </p>
            </div>
          </div>
        </li>
        <li>
          <p><span class="blueBar fz14"></span><span class="fz14">昨日券的使用人数</span></p>
          <p class="txtColor fz12">2021.07.09 ～ 2021.07.27｜昨日</p>
          <div class="box3">
            <div>
              <p class="blueColor fz14 date">7-27(二)</p>
              <p class="blueColor fz43">319<span class="fz14">次</span></p>
            </div>
            <div class="fz12">
              <p class="txtColor">
                环比<span class="dowmColr"
                  >5.9%<i class="el-icon-bottom"></i
                ></span>
              </p>
              <p class="txtColor">
                同比<span class="upColor">5.9%<i class="el-icon-top"></i></span>
              </p>
              <p class="txtColor">
                历史总量<span style="margin-left: 5px" class="color666"
                  >14800</span
                >
              </p>
            </div>
          </div>
        </li>
        <li>
          <p><span class="blueBar fz14"></span><span class="fz14">昨日用券的新用户数</span></p>
          <p class="txtColor fz12">2021.07.09 ～ 2021.07.27｜昨日</p>
          <div class="box3">
            <div>
              <p class="blueColor fz14 date">7-27(二)</p>
              <p class="blueColor fz43">319<span class="fz14">次</span></p>
            </div>
            <div class="fz12">
              <p class="txtColor">
                环比<span class="dowmColr"
                  >5.9%<i class="el-icon-bottom"></i
                ></span>
              </p>
              <p class="txtColor">
                同比<span class="upColor">5.9%<i class="el-icon-top"></i></span>
              </p>
              <p class="txtColor">
                历史总量<span style="margin-left: 5px" class="color666"
                  >14800</span
                >
              </p>
            </div>
          </div>
        </li>
        <li>
          <p><span class="blueBar fz14"></span><span class="fz14">优惠券的领取率</span></p>
          <p class="txtColor fz12">2021.07.09 ～ 2021.07.27｜昨日</p>
          <div class="box3">
            <div>
              <p class="blueColor fz14 date">7-27(二)</p>
              <p class="blueColor fz43">50<span class="fz14">%</span></p>
            </div>
            <div class="fz12">
              <p class="txtColor">
                环比<span class="dowmColr"
                  >5.9%<i class="el-icon-bottom"></i
                ></span>
              </p>
              <p class="txtColor">
                同比<span class="upColor">5.9%<i class="el-icon-top"></i></span>
              </p>
              <p class="txtColor">
                历史总量<span style="margin-left: 5px" class="color666"
                  >14800</span
                >
              </p>
            </div>
          </div>
        </li>
        <li>
          <p><span class="blueBar fz14"></span><span class="fz14">优惠券的使用率</span></p>
          <p class="txtColor fz12">2021.07.09 ～ 2021.07.27｜昨日</p>
          <div class="box3">
            <div>
              <p class="blueColor fz14 date">7-27(二)</p>
              <p class="blueColor fz43">46.8<span class="fz14">%</span></p>
            </div>
            <div class="fz12">
              <p class="txtColor">
                环比<span class="dowmColr"
                  >5.9%<i class="el-icon-bottom"></i
                ></span>
              </p>
              <p class="txtColor">
                同比<span class="upColor">5.9%<i class="el-icon-top"></i></span>
              </p>
              <p class="txtColor">
                历史总量<span style="margin-left: 5px" class="color666"
                  >14800</span
                >
              </p>
            </div>
          </div>
        </li>
      </ul>
    </el-card>
    <!-- 图1 -->
    <el-card shadow="never" class="my_card">
      <!-- 顶部区域 -->
      <div class="fl">
        <img
          src="../../assets/images/ticons/youhuiquan_list_icon@2x (1).png"
          alt=""
        />
        <span></span><b style="font-weight:500;">用券的订单总额</b>
      </div>
      <span class="text">2021.06.18 ～ 2021.07.20过去7天</span>
      <!-- 数字区域 -->
      <div class="mian">
        <!-- 左侧数字 -->
        <div class="lnum">
          <div class="m2">
            <span style="font-size: 14px"> &nbsp7-27 &nbsp&nbsp(二)</span>
            <span style="font-size: 39px; font-weight: 500"
              >26.2<span style="font-size: 12px">次</span>
            </span>
          </div>
          <div class="m3">
            <span style="font-size:12px;"
              >环比
              <span style="color: #ff4343; font-size: 12px; font-weight: 600"
                >5.9%</span
              ><i
                style="color: #ff4343; font-weight: 600"
                class="el-icon-top"
              ></i
            ></span>
            <span style="font-size:12px;"
              >同比
              <span style="color: #19e9aa; font-size: 12px; font-weight: 600"
                >5.9%</span
              ><i
                style="color: #19e9aa; font-weight: 600"
                class="el-icon-bottom"
              ></i
            ></span>
          </div>
        </div>
        <!-- 右侧数字 -->
        <div class="rnum">
          <p class="bigsize">
            <span class="fz12">合计：</span> <span class="fz28">31,123</span>
            <span class="fz12">万</span>
          </p>
          <p class="bigsize">
            <span class="fz12">均值：</span> <span class="fz28">31,123</span>
            <span class="fz12">万</span>
          </p>
        </div>
      </div>
      <div id="q1" style="margin-top: 30px"></div>
    </el-card>
    <!-- 图2 -->
    <el-card shadow="never" class="my_card">
      <!-- 顶部区域 -->
      <div class="fl">
        <img
          src="../../assets/images/newIcon/vipportrait_day_icon@2x.png"
          alt=""
        />
        <span></span><b style="font-weight:500;">优惠券对客单价的影响</b>
      </div>
      <span class="text">2021.06.18 ～ 2021.07.20过去7天</span>
      <div id="q2" style="margin-top: 30px"></div>
    </el-card>
    <!-- 图3 -->
    <el-card shadow="never" class="my_card">
      <!-- 顶部区域 -->
      <div class="fl">
        <img
          src="../../assets/images/newIcon/vipportrait_day_icon@2x.png"
          alt=""
        />
        <span></span><b style="font-weight:500;">优惠券补贴率</b>
      </div>
      <span class="text">2021.06.18 ～ 2021.07.20过去7天</span>
      <p style="margin: 10px 0 20px 5px" class="blueColor fz14">7-27（二）</p>
      <ul>
        <li>
          <p style="margin-left: 15px">
            <span
              style="transform: translate(-10px, 2px)"
              class="orangeBar"
            ></span
            ><span class="fz14">代金券</span>
          </p>
          <p class="blueColor">
            <span class="fz43">9.39</span><span class="fz14">%</span>
          </p>
        </li>
        <li>
          <p style="margin-left: 15px">
            <span style="transform: translate(-10px, 2px)" class="greBar"></span
            ><span class="fz14">满减券</span>
          </p>
          <p class="blueColor">
            <span class="fz43">9.39</span><span class="fz14">%</span>
          </p>
        </li>
        <li>
          <p style="margin-left: 15px">
            <span style="transform: translate(-10px, 2px)" class="pupBar"></span
            ><span class="fz14">折扣券</span>
          </p>
          <p class="blueColor">
            <span class="fz43">9.39</span><span class="fz14">%</span>
          </p>
        </li>
      </ul>
      <div id="q3" style="margin-top: 30px"></div>
    </el-card>
    <!-- 图4 -->
    <el-card shadow="never" class="my_card">
      <!-- 顶部区域 -->
      <div class="fl">
        <img
          src="../../assets/images/newIcon/vipportrait_day_icon@2x.png"
          alt=""
        />
        <span></span><b style="font-weight:500;">不用优惠券的使用情况</b>
      </div>
      <span class="text">2021.06.18 ～ 2021.07.20过去7天</span>
      <div id="q4" style="margin-top: 30px"></div>
    </el-card>
    <!-- 图5 -->
    <el-card shadow="never" class="my_card">
      <div class="fl">
        <img
          src="../../assets/images/newIcon/vipportrait_day_icon@2x.png"
          alt=""
        />
        <span></span><b style="font-weight:500;">近7日各类型优惠券使用的分布</b>
      </div>
      <span class="text">2021.06.18 ～ 2021.07.20过去7天</span>
      <div id="q5" style="margin-top: -50px"></div>
    </el-card>
    <!-- 图6 -->
    <el-card shadow="never" class="my_card">
      <!-- 标题 -->
      <div class="top clearfix">
        <div class="fl">
          <img
           src="../../assets/images/ticons/youhuiquan_title_icon@2x (1).png"
            alt=""
          />
          <span></span><b style="font-weight:500;">优惠券分析</b
          ><span class="text">优惠券经营分析汇总</span>
        </div>
        <div class="fr">
          <!-- @blur="datec" -->
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="→"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <!-- 图表 -->
      <div id="q6"></div>
      <!-- 两个小bar -->
      <ul class="ul">
        <li><span class="blueBar"></span> <span>发券数：30000</span></li>
        <li><span class="blueBar"></span> <span>用券数：29999</span></li>
      </ul>
      <!-- 两行文字 -->
      <div>
        <p class="fz12">不同面额优惠券的使用率</p>
        <p
          class="fz12"
          style="color: #0091ff; margin-top: 5px; font-weight: 550"
        >
          2021.07.13 ～ 2021.07.19 ｜ 过去7天-昨日
        </p>
      </div>
      <!-- 表格 -->
      <el-table class="my_card" :data="tableData" style="width: 100%" :header-cell-style="{background:'#eef1f6',color:'#606266',height:'30px'}">
        <el-table-column prop="t1" label="序号"> </el-table-column>
        <el-table-column prop="t2" label="优惠券面额">
        </el-table-column>
        <el-table-column prop="t3" label="7-19"> </el-table-column>
        <el-table-column prop="t4" label="7-18"> </el-table-column>
        <el-table-column prop="t5" label="7-17"> </el-table-column>
        <el-table-column prop="t6" label="7-16"> </el-table-column>
        <el-table-column prop="t7" label="7-15"> </el-table-column>
      </el-table>
    </el-card>
    <!-- 图7 -->
    <el-card shadow="never" class="my_card">
         <div class="fl">
        <img
          src="../../assets/images/newIcon/youhuiquan_mingan_icon.png"
          alt=""
        />
        <span></span><b style="font-weight:500;">近7日各类型优惠券使用的分布</b>
      </div>
      <span class="text"> <span class="fz16">xx面值</span>优惠券对于复购的影响力更大，多给新用户发送吧～</span>
      <p style="font-size:14px;margin-top:10px;margin-left:7px;">不同面额优惠券的复购率</p>
      <div class="pinkDate">
        <!-- 3个按钮 -->
    <el-radio-group v-model="radio1">
      <el-radio-button label="7天"></el-radio-button>
      <el-radio-button label="15天"></el-radio-button>
      <el-radio-button label="30天"></el-radio-button>
    </el-radio-group>
    <!-- 日期组件 -->
    <!--   @blur="datec" -->
         <el-date-picker
            class="rili"
          
            v-model="value1"
            type="daterange"
            range-separator="→"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
  </div>
  <div id="q7" style="margin-top:50px;"></div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio1:'7天',
      tableData: [
        {
          t1: "1",
          t2: "30至40",
          t3: "56.14%",
          t4: "56.14%",
          t5: "30.56%",
          t6: "30.56%",
          t7: "30.56%",
        },
        {
          t1: "2",
          t2: "10至20",
          t3: "53.2%",
          t4: "53.2%",
          t5: "30.56%",
          t6: "30.56%",
          t7: "30.56%",
        },
        {
          t1: "3",
          t2: "20至30",
          t3: "50.22%",
          t4: "50.22%",
          t5: "30.56%",
          t6: "30.56%",
          t7: "30.56%",
        },
      ],
      value1: new Date(),
      options1: [{ name: "昨日" }],
      data1: [
        { data: "6.21", name: "支付订单的订单金额的总和", val: 26.5 },
        { data: "6.22", name: "支付订单的订单金额的总和", val: 29 },
        { data: "6.23", name: "支付订单的订单金额的总和", val: 27.3 },
        { data: "6.24", name: "支付订单的订单金额的总和", val: 27.5 },
        { data: "6.25", name: "支付订单的订单金额的总和", val: 29.5 },
        { data: "6.26", name: "支付订单的订单金额的总和", val: 27.8 },
        { data: "6.29", name: "支付订单的订单金额的总和", val: 28.5 },
      ],
      data2: [
        {
          data: "6.21",
          name: "优惠后客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.22",
          name: "优惠后客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.23",
          name: "优惠后客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.24",
          name: "优惠后客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.25",
          name: "优惠后客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.26",
          name: "优惠后客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.29",
          name: "优惠后客单价",
          val: Math.ceil(Math.random() * 1000),
        },

        {
          data: "6.21",
          name: "普通客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.22",
          name: "普通客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.23",
          name: "普通客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.24",
          name: "普通客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.25",
          name: "普通客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.26",
          name: "普通客单价",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.29",
          name: "普通客单价",
          val: Math.ceil(Math.random() * 1000),
        },
      ],
      data3: [
        { data: "6.21", name: "满减券", val: 740 },
        { data: "6.22", name: "满减券", val: 750 },
        { data: "6.23", name: "满减券", val: 850 },
        { data: "6.24", name: "满减券", val: 760 },
        { data: "6.25", name: "满减券", val: 600 },
        { data: "6.26", name: "满减券", val: 750 },
        { data: "6.27", name: "满减券", val: 580 },

        { data: "6.21", name: "代金券", val: 640 },
        { data: "6.22", name: "代金券", val: 650 },
        { data: "6.23", name: "代金券", val: 750 },
        { data: "6.24", name: "代金券", val: 660 },
        { data: "6.25", name: "代金券", val: 500 },
        { data: "6.26", name: "代金券", val: 650 },
        { data: "6.27", name: "代金券", val: 480 },

        { data: "6.21", name: "折扣券", val: 540 },
        { data: "6.22", name: "折扣券", val: 550 },
        { data: "6.23", name: "折扣券", val: 650 },
        { data: "6.24", name: "折扣券", val: 560 },
        { data: "6.25", name: "折扣券", val: 400 },
        { data: "6.26", name: "折扣券", val: 550 },
        { data: "6.27", name: "折扣券", val: 380 },
      ],
      data4: [
        {
          data: "6.21",
          name: "满100减10",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.22",
          name: "满100减10",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.23",
          name: "满100减10",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.24",
          name: "满100减10",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.25",
          name: "满100减10",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.26",
          name: "满100减10",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.27",
          name: "满100减10",
          val: Math.ceil(Math.random() * 1000),
        },

        { data: "6.21", name: "8折", val: Math.ceil(Math.random() * 1000) },
        { data: "6.22", name: "8折", val: Math.ceil(Math.random() * 1000) },
        { data: "6.23", name: "8折", val: Math.ceil(Math.random() * 1000) },
        { data: "6.24", name: "8折", val: Math.ceil(Math.random() * 1000) },
        { data: "6.25", name: "8折", val: Math.ceil(Math.random() * 1000) },
        { data: "6.26", name: "8折", val: Math.ceil(Math.random() * 1000) },
        { data: "6.27", name: "8折", val: Math.ceil(Math.random() * 1000) },

        {
          data: "6.21",
          name: "5元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.22",
          name: "5元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.23",
          name: "5元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.24",
          name: "5元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.25",
          name: "5元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.26",
          name: "5元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.27",
          name: "5元代金券",
          val: Math.ceil(Math.random() * 1000),
        },

        {
          data: "6.21",
          name: "6元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.22",
          name: "6元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.23",
          name: "6元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.24",
          name: "6元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.25",
          name: "6元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.26",
          name: "6元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.27",
          name: "6元代金券",
          val: Math.ceil(Math.random() * 1000),
        },

        {
          data: "6.21",
          name: "7元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.22",
          name: "7元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.23",
          name: "7元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.24",
          name: "7元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.25",
          name: "7元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.26",
          name: "7元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
        {
          data: "6.27",
          name: "7元代金券",
          val: Math.ceil(Math.random() * 1000),
        },
      ],
      data5:[
        { data: "6.21", name: "小程序", val: Math.ceil(Math.random()*1000) },
        { data: "6.22", name: "小程序", val: Math.ceil(Math.random()*1000) },
        { data: "6.23", name: "小程序", val: Math.ceil(Math.random()*1000) },
        { data: "6.24", name: "小程序", val: Math.ceil(Math.random()*1000) },
        { data: "6.25", name: "小程序", val: Math.ceil(Math.random()*1000) },
        { data: "6.26", name: "小程序", val: Math.ceil(Math.random()*1000) },
        { data: "6.27", name: "小程序", val: Math.ceil(Math.random()*1000) },

        { data: "6.21", name: "安卓端", val:Math.ceil(Math.random()*1000)},
        { data: "6.22", name: "安卓端", val:Math.ceil(Math.random()*1000)},
        { data: "6.23", name: "安卓端", val:Math.ceil(Math.random()*1000)},
        { data: "6.24", name: "安卓端", val:Math.ceil(Math.random()*1000)},
        { data: "6.25", name: "安卓端", val:Math.ceil(Math.random()*1000)},
        { data: "6.26", name: "安卓端", val:Math.ceil(Math.random()*1000)},
        { data: "6.27", name: "安卓端", val:Math.ceil(Math.random()*1000)},

        { data: "6.21", name: "iOS端", val:Math.ceil(Math.random()*1000)},
        { data: "6.22", name: "iOS端", val:Math.ceil(Math.random()*1000)},
        { data: "6.23", name: "iOS端", val:Math.ceil(Math.random()*1000)},
        { data: "6.24", name: "iOS端", val:Math.ceil(Math.random()*1000)},
        { data: "6.25", name: "iOS端", val:Math.ceil(Math.random()*1000)},
        { data: "6.26", name: "iOS端", val:Math.ceil(Math.random()*1000)},
        { data: "6.27", name: "iOS端", val:Math.ceil(Math.random()*1000)},

        { data: "6.21", name: "抖音", val:Math.ceil(Math.random()*1000)},
        { data: "6.22", name: "抖音", val:Math.ceil(Math.random()*1000)},
        { data: "6.23", name: "抖音", val:Math.ceil(Math.random()*1000)},
        { data: "6.24", name: "抖音", val:Math.ceil(Math.random()*1000)},
        { data: "6.25", name: "抖音", val:Math.ceil(Math.random()*1000)},
        { data: "6.26", name: "抖音", val:Math.ceil(Math.random()*1000)},
        { data: "6.27", name: "抖音", val:Math.ceil(Math.random()*1000)},

        { data: "6.21", name: "小红书", val:Math.ceil(Math.random()*1000)},
        { data: "6.22", name: "小红书", val:Math.ceil(Math.random()*1000)},
        { data: "6.23", name: "小红书", val:Math.ceil(Math.random()*1000)},
        { data: "6.24", name: "小红书", val:Math.ceil(Math.random()*1000)},
        { data: "6.25", name: "小红书", val:Math.ceil(Math.random()*1000)},
        { data: "6.26", name: "小红书", val:Math.ceil(Math.random()*1000)},
        { data: "6.27", name: "小红书", val:Math.ceil(Math.random()*1000)},
      ]
    };
  },
  mounted() {
    this.init("q1", this.data1);
    this.init("q2", this.data2, 400);
    this.init("q3", this.data3, 330);
    this.init("q4", this.data4, 400);
    this.init2();
    this.init3();
    this.init("q7",this.data5,450)
  },
  methods: {
    //线图
    init(id, data, height) {
      const chart = new this.$chart({
        container: id,
        autoFit: true,
        height: height || 320,
        padding: [10, 20, 65, 50],
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      if (id == "q1") {
        chart.scale("val", {
          min: 26,
          max: 30,
        });

        chart.axis("val", {
          label: {
            formatter: (val) => {
              return val + "万";
            },
          },
        });

        chart.line().position("data*val").shape("smooth").color("name");
      } else if (id == "q2" || id == "q3") {
        chart.scale("val", {
          min: 0,
          max: 1000,
        });
        chart
          .line()
          .position("data*val")
          .shape("smooth")
          .color("name", ["#FF944C", "#6DD400", "#9D6BFF"]);
      } else if (id == "q4") {
        chart.scale("val", {
          min: 0,
          max: 1000,
        });
        chart
          .line()
          .position("data*val")
          .shape("smooth")
          .color("name", [
            "#5B8FF9",
            "#5AD8A6",
            "#7B4DFF",
            "#F6BD16",
            "#E8684A",
          ]);
      } else if (id == "q7"){
              chart.scale("val", {
          min: 0,
          max: 1000,
        });
        chart
          .line()
          .position("data*val")
          .shape("smooth")
          .color("name", [
            "#44D7B6",
            "#B620E0 ",
            "#3F51B5",
            "#5677FC",
            "#FF944C",
          ]);
      }

      chart.tooltip({
        showCrosshairs: false,
        shared: true,
        showMarkers: true, //移入图表展示圆点
        itemTpl: `
                    <div style="margin-bottom: 10px;list-style:none;">
                    <span style="background-color:{color}; margin-left:5px;" class="g2-tooltip-marker marr0"></span>
                    {name}:{value}
                    </div>
                `, // 自定义 toolTip 样式
      });

      // chart.point().position("data*val").shape("circle");

      chart.render();
    },
    // 饼图1
    init2() {
      let data = [
        { item: "代金券", count: 100, percent: 0.37 },
        { item: "折扣券", count: 100, percent: 0.43 },
        { item: "满减券", count: 100, percent: 0.25 },
      ];

      let chart = new this.$chart({
        container: "q5",
        autoFit: true,
        height: 450,
        padding: [0, 0, -20, 0],
      });

      chart.data(data);

      chart.coordinate("theta", {
        radius: 0.6,
      });

      chart.scale("percent", {
        formatter: (val) => {
          val = val * 100 + "%";
          // return val;
        },
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });
      chart.axis(false); // 关闭坐标轴
      const interval = chart
        .interval()
        .adjust("stack")
        .position("percent")
        .color("item", ["#F84F52", "#B840F3", "#FACA31"])
        .label("percent", {
          offset: -40,
          style: {
            textAlign: "center",
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .45)",
            fill: "#fff",
          },
        })
        .tooltip("item*percent", (item, percent) => {
          percent = percent * 100 + "%";
          return {
            name: item,
            value: percent,
          };
        })
        .style({
          lineWidth: 1,
          stroke: "#fff",
        });
      chart.interaction("element-single-selected");
      chart.render();
    },
    // 饼图2
    init3() {
      let data = [
        { item: "用券成交用户", count: 100, percent: 0.37 },
        { item: "正常成交用户", count: 100, percent: 0.73 },
      ];

      let chart = new this.$chart({
        container: "q6",
        autoFit: true,
        height: 300,
        padding: [-30, 0, -10, 0],
      });

      chart.data(data);

      chart.coordinate("theta", {
        radius: 0.7,
      });

      chart.scale("percent", {
        formatter: (val) => {
          val = val * 100 + "%";
          // return val;
        },
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });
      chart.axis(false); // 关闭坐标轴
      const interval = chart
        .interval()
        .adjust("stack")
        .position("percent")
        .color("item", ["#5B8FF9", "#5AD8A6"])
        .tooltip("item*percent", (item, percent) => {
          percent = percent * 100 + "%";
          return {
            name: item,
            value: percent,
          };
        })
        .style({
          lineWidth: 1,
          stroke: "#fff",
        });

      chart.interaction("element-single-selected");
      chart.render();
    },
  },
};
</script>

<style lang="less">
.discountCoupon {
  padding-bottom: 20px;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  .my_card {
    width: 48%;
    height: 500px;
    margin-top: 20px;
    // 日期选择器组件样式
      .el-range-editor--mini.el-input__inner {
            width: 200px;
          }
      .el-date-editor .el-range-separator {
            padding: 0px 4px;
            line-height: 18px;
            width: 5%;
            color: #c6c8cc;
          }
    // 顶部文字样式
    .fl {
      font-size: 16px;
      display: flex;
      align-items: center;
      b {
        margin-left: 10px;
      }
      img {
        width: 24px;
      }
    }
    .text {
      display: block;
      margin-left: 12px;
      color: #333;
      font-size: 12px;
      line-height: 24px;
      margin-top: 10px;
    }
    &:nth-child(1) {
      width: 97.2%;
      margin-top: 30px;
      height: 500px;
      // 顶部区域样式
      .top6 {
        margin-top: -5px;
        .fl {
          float: left;
          font-size: 16px;
          display: flex;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
        }
        .fr {
          float: right;
          color: #999999;
          font-size: 12px;
          p {
            img {
              width: 16px;
              vertical-align: middle;
              //   margin-right: 10px;
            }
          }
          .my-select {
            margin-left: 10px;
          }
        }
      }
      //8个盒子区域
      ul {
        margin-left: 20px;
        margin-top: 20px;
        height: 380px;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: space-around;
        li {
          box-sizing: border-box;
          width: 24%;
          height: 180px;
          background: rgba(50, 126, 255, 0.08);
          border-radius: 6px;
          padding: 20px;
          > p {
            margin-left: 10px;
            &:nth-child(1) {
              margin-left: 6px;
              margin-bottom: 10px;
            }
          }
          .box3 {
            margin-left: 7px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .date {
              margin-top: -10px;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
    &:nth-child(2) {
      //数字样式
      .mian {
        display: flex;
        justify-content: space-between;
        .lnum {
          display: flex;
          .m2 {
            margin-left: 20px;
            margin-bottom: -5px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            color: #0091ff;
          }
          .m3 {
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }
        }
        .rnum {
          margin-right: 60px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &:after {
            content: "";
            width: 2px;
            height: 40px;
            background-color: #333;
            position: absolute;
            top: 17px;
            left: -20px;
          }
        }
      }
      // 图4单独样式部分
      .numDate {
        margin-top: 10px;
        margin-left: 13px;
        .date {
          color: #327eff;
        }
        .num {
          display: flex;
          justify-content: space-between;
          .right {
            margin-right: 60px;
          }
        }
      }
    }
    &:nth-child(4) {
      width: 97.2%;
      height: 550px;
      ul {
        display: flex;
        justify-content: space-between;
        li {
          &:nth-child(2) {
            transform: translate(-150px, 0px);
          }
          &:nth-child(3) {
            transform: translate(-150px, 0px);
          }
        }
      }
    }
    &:nth-child(7) {
      position: relative;
      height: 650px;
      .el-table{
          border: none !important;
        }
      .my_card{
        margin-top: 20px;
        .cell{
          text-align: center;
          height: 47px;
          line-height: 45px;
          font-size: 12px;
          font-weight: 400;
        }
       .el-table__header tr,
        .el-table__header th {
          padding: 0;
          height: 40px;
        }
        .el-table__header tr,
        .el-table__header th .cell{
          padding: 0;
          height: 40px;
          font-weight: 500;
        }
      }
      .top {
        .fl {
          float: left;
          font-size: 16px;
          display: flex;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
          .text {
            margin-left: 12px;
            color: #999999;
            font-size: 12px;
            line-height: 24px;
          }
        }
        .fr {
          float: right;
          color: #999999;
          font-size: 12px;
          margin-top: 5px;
      
        }
      }
      .ul {
        position: absolute;
        top: 90px;
        right: 36px;
        li:nth-child(1) {
          margin-bottom: 10px;
        }
      }
    }
    &:nth-child(8){
      height: 650px;
      .el-radio-button__inner{
        font-size: 12px;
      }
      .pinkDate{
        margin-top: 10px;
        margin-left: 150px;
        .rili{
          transform: translate(10px, 2px);
        }
      }
    }
  }
  //公共样式区
  .marr0 {
    margin-right: 0 !important;
  }
  .fz14 {
    font-size: 14px;
  }
  .fz28 {
    font-size: 28px;
    font-weight: 500;
  }
  .fz16{
    font-size: 16px;
  }
  .fz12 {
    font-size: 12px;
  }
  .fz43 {
    font-size: 43px;
  }
  .orangeBar,
  .greBar,
  .pupBar {
    display: inline-block;
    width: 4px;
    height: 14px;
    border-radius: 3px;
    background-color: #ff9d4d;
  }
  .greBar {
    background-color: #5ad8a6;
  }
  .pupBar {
    background-color: #9d6bff;
  }
  .blueBar {
    display: inline-block;
    width: 4px;
    height: 14px;
    background: #327eff;
    border-radius: 3px;
    transform: translate(-10px, 3px);
  }
  .dowmColr {
    color: #19e9aa;
    margin-left: 5px;
  }
  .upColor {
    color: #ff4343;
    margin-left: 5px;
  }
  .color666 {
    color: #666666;
  }
  .blueColor {
    color: #327eff;
  }
  .txtColor {
    color: #7e858c;
    white-space: nowrap;
  }
}
</style>